import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#FAF7F1',
          padding: '24px'
        }}>
          <div style={{
            maxWidth: '400px',
            background: '#F3EEE7',
            borderRadius: '14px',
            padding: '32px',
            textAlign: 'center',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05), 0 8px 24px rgba(0,0,0,0.06)'
          }}>
            <h1 style={{
              fontFamily: 'Cormorant, serif',
              fontSize: '28px',
              color: '#231E1A',
              marginBottom: '12px'
            }}>
              Something broke
            </h1>
            <p style={{
              color: '#9C6B4A',
              fontSize: '15px',
              marginBottom: '24px',
              lineHeight: '1.5'
            }}>
              We're on it. Please refresh the page or contact support if this continues.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#9C6B4A',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '15px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
